import styled from 'styled-components'
import theme from '../../styles/theme'
import externalLinkIcon from '../../asset/external-link.svg'
const StyledCard = styled.div`
  border: 1px solid ${theme.color.border};
  padding: 1rem;
  border-radius: 4px;
  & > a {
    text-decoration: underline;
    :after {
      display: inline-block;
      content: '';
      background-image: url(${externalLinkIcon});
      background-size: 15px 15px;
      height: 15px;
      width: 15px;
    }
`

export { StyledCard }
